<script>
import {setObject} from '../../common/util';
export default {
  props: {
      codeEvent: {
         type: Function
      },
      searchEvent: {
          type: Function
      },
      editOption: {
          type: Object
      },
      changeEdit: {
          type: Function
      }
  },
  data() {
      return {
          upload: {
              url: `${location.origin}/admin/api/datamall/V1.0/datamall/photo`
          },
          editQuery: {
              id: '',
              name: '',
              price: '',
              firstTradeId: '',
              secondTradeId: '',
              provinceId: '',
              cityId: '',
              type: '',
              keywords: '',
              introduction: '',
			  imageUrl: '',
              column: '',
              childrenData: []
          },
          files: [],
          header: {
              token: this.$store.state.env.userInfo.token
          }
      }
  },
  methods: {
      initQuery(row) {
          this.$refs.carousel.clearValidate();
          this.files = [];
          this.$clearObject(this.editQuery);
          const type = this.editOption.type;
          Object.is(type, 1) && setObject(this.editQuery, row);
          if (Object.is(type, 1)) {
              row.imageUrl && this.files.push({name: row.imageUrl, url: row.imageUrl});
          }
          if (Object.is(type, 0)) {
              this.editQuery.childrenData = [];
          }
      },
      async submit() {
        const {code} = await this.codeEvent(this.editQuery);
        if (Object.is(code, 200)) {
            this.editOption.dialog = false;
            this.$message.success(`${this.editOption.title}成功`);
            this.searchEvent();
        }
      },
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePreview(file) {
        console.log(file);
      },
      handleSuccess(res) {
          const {code, data} = res;
          if (code === 200) {
              this.editQuery.imageUrl = data;
          } else {
              this.$refs.upload.clearFiles();
              this.$message.error('文件上传失败');
          }
      },
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${ file.name }？`);
      },
      submitForm(formName) {
           this.$refs[formName].validate((valid) => {
           valid && this.submit();
        });
      },
      change(value, type) {
        if (type && Object.is(type, 'provinceId')) {
            this.editQuery.cityId = '';
        }
        if (type && Object.is(type, 'firstTradeId')) {
            this.editQuery.secondTradeId = '';
        }
        this.$emit('changeEdit', {value, type});
     },
     handleClick() {
         console.log(this.editQuery.childrenData);
         this.editQuery.childrenData.push({name: '', price: ''});
     }
  },
  mounted() {
  },
  computed: {
  },
  components: {
      quillEditor: () => import('@/components/quillEditor')
  }
}
</script>
<template>
<div class="edit">
<el-dialog
    :title="editOption.title"
    :width="editOption.width"
    :visible.sync="editOption.dialog"
    :modal-append-to-body="false"
    :close-on-click-modal="false">
    <el-form :model="editQuery" ref="carousel">
      <el-form-item label="名称" label-width="80px" prop="name"
        :rules="[{required: true, message: '不能为空', trigger: 'blur'}]">
          <el-input v-model="editQuery.name"
            placeholder="请输入名称"
            class="common-width9"
          ></el-input>
      </el-form-item>
      <el-form-item label="价格" label-width="80px" prop="price"
        :rules="[{required: true, message: '不能为空', trigger: 'blur'}]">
          <el-input v-model="editQuery.price"
            placeholder="请输入价格"
            class="common-width9"
          ></el-input>
      </el-form-item>

      <el-form-item label="省份" label-width="80px" prop="provinceId"
        :rules="[{required: true, message: '不能为空', trigger: 'blur'}]">
            <el-select v-model="editQuery.provinceId" class="common-width9"
			    placeholder="省份"
                @change="change($event, 'provinceId')"
			>
				<el-option
					v-for="item in editOption.options.provinceId"
					:key="item.districtId"
					:label="item.districtName"
					:value="item.districtId"
				>
				</el-option>
			</el-select>
      </el-form-item>
      <el-form-item label="城市" label-width="80px" prop="cityId"
        :rules="[{required: true, message: '不能为空', trigger: 'blur'}]">
            <el-select v-model="editQuery.cityId" class="common-width9"
			    placeholder="城市"
			>
				<el-option
					v-for="item in editOption.options.cityId"
					:key="item.districtId"
					:label="item.districtName"
					:value="item.districtId"
				>
				</el-option>
			</el-select>
      </el-form-item>

      <el-form-item label="一级行业" label-width="80px" prop="firstTradeId"
        :rules="[{required: true, message: '不能为空', trigger: 'blur'}]">
            <el-select v-model="editQuery.firstTradeId" class="common-width9"
			    placeholder="一级行业"
                 @change="change($event, 'firstTradeId')"
			>
				<el-option
					v-for="item in editOption.options.firstTradeId"
					:key="item.tradeId"
					:label="item.tradeName"
					:value="item.tradeId"
				>
				</el-option>
			</el-select>
      </el-form-item>
      <el-form-item label="二级行业" label-width="80px" prop="secondTradeId"
        :rules="[{required: true, message: '不能为空', trigger: 'blur'}]">
            <el-select v-model="editQuery.secondTradeId" class="common-width9"
			    placeholder="二级行业"
			>
				<el-option
					v-for="item in editOption.options.secondTradeId"
					:key="item.tradeId"
					:label="item.tradeName"
					:value="item.tradeId"
				>
				</el-option>
			</el-select>
      </el-form-item>
      <el-form-item label="关键词" label-width="80px" prop="keywords"
        :rules="[{required: true, message: '不能为空', trigger: 'blur'}]">
          <el-input v-model="editQuery.keywords"
            placeholder="多个关键词以逗号分隔"
            class="common-width9"
          ></el-input>
      </el-form-item>
      <el-form-item label="报告目录" label-width="80px" prop="column"
        :rules="[{required: true, message: '不能为空', trigger: 'blur'}]">
          <el-input v-model="editQuery.column"
            placeholder="多个报告目录以逗号分隔"
            class="common-width9"
          ></el-input>
      </el-form-item>
      <el-form-item label="报告类型" label-width="80px" prop="secondTradeId"
        :rules="[{required: true, message: '不能为空', trigger: 'blur'}]">
            <el-select v-model="editQuery.type" class="common-width9"
			    placeholder="报告类型"
			>
                <el-option :value=0 label="普通报告"></el-option>
                <el-option :value=1 label="专题报告"></el-option>
			</el-select>
      </el-form-item>
      <el-form-item label="报告内容" label-width="80px" prop="childrenData" v-if="editQuery.type === 1"
        :rules="[{required: true, message: '不能为空', trigger: 'blur'}]">
            <el-button type="text" @click="handleClick" v-if="editQuery.childrenData.length === 0">+</el-button>
            <div class="flex-item common-width9" v-for="(item, index) in editQuery.childrenData" :key="index">
                <el-input v-model="item.name" placeholder="输入报告名称"></el-input>
                <el-input v-model="item.price" type="number" placeholder="输入报告价格"></el-input>
                <el-button type="text" @click="handleClick">+</el-button>
            </div>
      </el-form-item>
      <el-form-item label="头图地址" label-width="80px" prop="imageUrl"
        :rules="[{required: true, message: '不能为空', trigger: 'blur'}]">
            <el-upload res="upload"
                :action="upload.url"
                :on-remove="handleRemove"
                accept="image/*"
                :limit="1"
                :file-list="files"
                :headers="header"
                :on-success="handleSuccess"
            >
                <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
      </el-form-item>
       <el-form-item label="简介" label-width="80px" prop="introduction"
        :rules="[{required: true, message: '不能为空', trigger: 'blur'}]">
          <quill-editor :article="editQuery" props="introduction" :action="upload.url" class="common-width9"></quill-editor>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
          <el-button @click="editOption.dialog = false" size="small">取消</el-button>
          <el-button type="success"
            @click="submitForm('carousel')" size="small"
         >提交</el-button>
    </div>
</el-dialog>
</div>
</template>
<style scoped lang="stylus">
.flex-item {
    display: flex;
    margin-bottom: 10px;
}
</style>
